package com.github.jangalinski.com.github.jangalinski.tabweb.site.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initMarkdownPagesPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("MarkdownPages.md", FrontMatterElement.Builder { addScalar("title", "Markdown pages"); addScalar("subtitle", "Kobweb Markdown rendered inside the shared Tabler page shell."); }))
}

@Page("/markdown-pages")
@Layout("com.github.jangalinski.tabweb.site.MarkdownTabwebLayout")
@Composable
fun MarkdownPagesPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This page is generated from Markdown and uses the same navigation, page header, content container, and footer as the Kotlin-authored pages.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("front-matter") }) {
        org.jetbrains.compose.web.dom.Text("Front matter")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("title")
        }
        org.jetbrains.compose.web.dom.Text(" and ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("subtitle")
        }
        org.jetbrains.compose.web.dom.Text(" values above are rendered by the shared Tabler page header. Markdown content begins below the page header so the page has one main title.")
    }
}
